import React, { memo, useCallback } from 'react'
import Input from '@sl/ui-library/molecules/Input'

const checkSize = val => parseInt(val, 10) > 8
const TrimNumber = number => Math.round(parseInt(number.toString().replace(/^(0+)/g, ''), 10))

const MoveSizeInput = ({ state, setState }) => {
  const { clicked, valid, value } = state.moveSize
  const handleInput = useCallback(e => {
    const event = e
    const newVal = e.target.value || ''
    switch (event.type) {
      case 'click':
      case 'focus':
        setState(prev => ({
          ...prev,
          moveSize: {
            ...prev.moveSize,
            clicked: true,
          },
        }))
        break
      case 'blur':
        setState(prev => ({
          ...prev,
          moveSize: {
            ...prev.moveSize,
            valid: checkSize(prev.moveSize.value),
          },
        }))
        break
      case 'change':
        setState(prev => ({
          ...prev,
          moveSize: {
            ...prev.moveSize,
            value: TrimNumber(newVal),
            valid: checkSize(newVal),
          },
        }))
        break
      default:
        break
    }
  }, [])
  const content = (
    <>
      <Input
        onChange={handleInput}
        id="MooveFormLandingMoveSizeInput"
        onBlur={handleInput}
        onClick={handleInput}
        onFocus={handleInput}
        error={clicked && !valid}
        success={valid}
        value={value}
        label="Surface à déménager (m²)"
        style={{ width: '100%' }}
        type="number"
      />
    </>
  )

  return content
}

export default memo(MoveSizeInput)
